export default function PushNotifications(props: any) {
  const { message } = props;
  return (
    <>
      <div className="ele-push-notification text-center mt-5 mb-5">
        <div className="ele-push-notification-body text-center">
          { message.color === 'blue' ?
            <h5 className="text-bpPrimary ele-push-notification-title">{message.title} </h5>
            :
            <h5 className="text-bpRed ele-push-notification-error-title">{message.title} </h5>
          }
          <p className="text-secondaryText ele-push-notification-text">{message.text}</p>
        </div>
      </div>
    </>
  )
}
